<div *ngIf="isVisible">
<div class="max-w-[100vw] mobileScreen"><stdout-modal color="white">
    <stdout-modal-header>{{title}}</stdout-modal-header>
    <stdout-modal-content>{{content}}</stdout-modal-content>
</stdout-modal></div>
</div>
